import React from "react";
import { EmendasParlamentaresProvider } from "./context/emendas-parlamentares-context";
import { EmendasParlamentares } from "./emendas-parlamentares";
import { BaseInternalFormFactory } from "../../base-internal-form/base-internal-form-factory";

const EmendasParlamentaresFactory = () => {
    return (
        <BaseInternalFormFactory pageTitle={"Emendas Parlamentares"}>
            <EmendasParlamentaresProvider>
                <EmendasParlamentares />
            </EmendasParlamentaresProvider>
        </BaseInternalFormFactory>
    );
};

export default EmendasParlamentaresFactory;
